import { Space, Tag } from "antd";

export const lineData =  [
    {
      name: '5k',
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: '10k',
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: '15k',
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: '25k',
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: '30k',
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: '35k',
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: '40k',
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ];

  export const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: text => <a>{text}</a>,
    },
    {
      title: 'Age',
      dataIndex: 'age',
      key: 'age',
    },
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
    },
    {
      title: 'Tags',
      key: 'tags',
      dataIndex: 'tags',
      render: tags => (
        <>
          {tags.map(tag => {
            let color = tag.length > 5 ? 'geekblue' : 'green';
            if (tag === 'loser') {
              color = 'volcano';
            }
            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <a>Invite {record.name}</a>
          <a>Delete</a>
        </Space>
      ),
    },
  ];

export const data = [
    {
      key: '1',
      name: 'John Brown',
      age: 32,
      address: 'New York No. 1 Lake Park',
      tags: ['nice', 'developer'],
    },
    {
      key: '2',
      name: 'Jim Green',
      age: 42,
      address: 'London No. 1 Lake Park',
      tags: ['loser'],
    },
    {
      key: '3',
      name: 'Joe Black',
      age: 32,
      address: 'Sidney No. 1 Lake Park',
      tags: ['cool', 'teacher'],
    },
  ];


//   const DATA_COUNT = 7;
// const NUMBER_CFG = {count: DATA_COUNT, min: -100, max: 100};

// const labels = Utils.months({count: 7});
const dataChart = {
  // labels: labels,
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [
    {
      label: 'Dataset 1',
      data: [65, 59, 80, 81, 56, 55, 40]
      // borderColor: Utils.CHART_COLORS.red,
      // backgroundColor: Utils.transparentize(Utils.CHART_COLORS.red, 0.5),
    },
    {
      label: 'Dataset 2',
      data: [28, 48, 40, 19, 86, 27, 90]
      // borderColor: Utils.CHART_COLORS.blue,
      // backgroundColor: Utils.transparentize(Utils.CHART_COLORS.blue, 0.5),
    }
  ]
};

export const DaysInArabic =[
  "الأحد",
  "الإثنين",
  "الثلاثاء",
  "الأربعاء",
  "الخميس",
  "الجمعة",
  "السبت",
]